"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardCustomizationLogger = void 0;
var pluginUtils_1 = require("./pluginUtils");
function addPluginInfoToMessage(plugin, message) {
    return plugin ? pluginUtils_1.pluginDebugStr(plugin) + ": " + message : message;
}
/**
 * Common logger to use for all events that occur during customization. The logger is responsible for adding
 * information about plugin whose registration code triggered those events.
 */
var DashboardCustomizationLogger = /** @class */ (function () {
    function DashboardCustomizationLogger() {
        var _this = this;
        this.setCurrentPlugin = function (plugin) {
            _this.currentPlugin = plugin;
        };
        this.log = function (message) {
            var optionalParams = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                optionalParams[_i - 1] = arguments[_i];
            }
            // eslint-disable-next-line no-console
            console.log(addPluginInfoToMessage(_this.currentPlugin, message), optionalParams);
        };
        this.warn = function (message) {
            var optionalParams = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                optionalParams[_i - 1] = arguments[_i];
            }
            console.warn(addPluginInfoToMessage(_this.currentPlugin, message), optionalParams);
        };
        this.error = function (message) {
            var optionalParams = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                optionalParams[_i - 1] = arguments[_i];
            }
            console.error(addPluginInfoToMessage(_this.currentPlugin, message), optionalParams);
        };
    }
    return DashboardCustomizationLogger;
}());
exports.DashboardCustomizationLogger = DashboardCustomizationLogger;
//# sourceMappingURL=customizationLogging.js.map